import Constants from "../../rz-status_constants";
import { useState, useEffect } from 'react';
import { IDateFilterable } from '../../rz-status_models';

export default function({data, onFilterChange}: {data:IDateFilterable[], onFilterChange:Function })  {
	const [value, setValue] = useState("")
	const OPTION_FORMAT = "MM_YYYY";

	function handleChange(e) {
		setValue(e.target.value)
		onFilterChange(() => applyOnData); // Update exposed function
	};

	// Expose filter function via callback
	useEffect(() => {
		onFilterChange(() => applyOnData);
	}, [data]);

	function formatMonth(date:Date):string {
		return(Constants.DateFormat.monthnames[date.getMonth()]+" "+date.getFullYear());
	}


	function applyOnData (data:IDateFilterable[]):IDateFilterable[] {
		if (value == "") {
			return(data);
		}
		var filtered:IDateFilterable[] = [];
		var selectedMonthBegin = moment(value, OPTION_FORMAT);
		var selectedMonthEnd =moment(value, OPTION_FORMAT).add(1, 'months').subtract(1, "seconds");		
		for (var i:number=0; i < data.length; i++) {
			if ((moment(data[i].startDate).isBetween(selectedMonthBegin, selectedMonthEnd)) || (moment(data[i].endDate).isBetween(selectedMonthBegin, selectedMonthEnd))) {				
				filtered.push(data[i]);
			}
		}
		return(filtered);
	}

    var dates:Date[] = [];

    for (var i:number=0; i < data.length; i++) {
        dates.push(data[i].startDate);
        dates.push(data[i].endDate);
    }
    dates.sort(function (a:Date,b:Date) {
        return(a.getTime() - b.getTime());
    });
    var dateObjects = {}
    dates.forEach(date => (dateObjects[moment(date).local(true).format(OPTION_FORMAT)] = formatMonth(date)))

 	return <section className="filter">
            <label htmlFor="monthFilterPlanned" className="filterLabel">Filtern: </label>
            <div className="selectStyle">
                <select name="month" id="monthFilterPlanned" onChange={handleChange}>
                    <option value="NONE">Alles</option>
                    {Object.entries(dateObjects).map((obj, i) => <option key={i} value={obj[0]}>{obj[1]}</option>)}							
                </select>
            </div>
        </section>
}